import { StatusTransition } from '../../types/interfaces/StatusTransition';

import Api from './api';
import IStatusTransitionsApi from './interfaces/statusTransitionsApi';

class StatusTransitionsApi
  extends Api<StatusTransition>
  implements IStatusTransitionsApi
{
  constructor(abortController: AbortController) {
    super('statusTransition/', abortController);
  }
}

export default StatusTransitionsApi;
